import { ActivityLogsList } from "#src/batteries-included-components/Layouts/ActivityLogs/ActivityLogsList";
import { AssetType } from "@validereinc/domain";
import React from "react";
import { EquipmentUpdateStatusBanner } from "../EquipmentUpdateStatusBanner";

export const ChangeLogTab = ({ resourceId }: { resourceId: string }) => {
  return (
    <>
      <EquipmentUpdateStatusBanner />
      <ActivityLogsList
        resourceId={resourceId}
        resourceType={{ name: AssetType.EQUIPMENT }}
      />
    </>
  );
};
